import axios from "@/axios";

export function ImportCancel() {
  return axios.delete<Array<string>>("/products/import/nomenclature");
}
